import { createContext } from 'react';
const { Provider, Consumer } = createContext();
export { Consumer, Provider };